import React, { useEffect, useContext } from "react";

import moment from "moment/min/moment-with-locales.min";
import { renderRoutes } from "react-router-config";
import { Switch, withRouter } from "react-router-dom";
import screens from "screens";
import { Store, StoreContext } from "shared/store";
import { useInfo } from "utils/hooks/info";
import {useTranslation} from "react-i18next";

const App = () => {
  const { getInfo, getCommonInfo } = useInfo();
  const { loggedIn } = useContext(StoreContext);
  //moment.locale("fr");

  const { i18n } = useTranslation();
  useEffect(() => {
    moment.locale(i18n.language);
    console.log('languageChanged', i18n.language, moment().format("MMMM YYYY"));
  }, [i18n]);


  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    if (loggedIn) {
      getCommonInfo();
    }
  }, [loggedIn]);

  return (
    <div>
      <Switch>{renderRoutes(screens)}</Switch>
    </div>
  );
};

export default Store(withRouter(App));
